/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BankBulkResponse } from '../../models/bank-bulk-response';
import { BankUpdate } from '../../models/bank-update';

export interface PutApiBankV1Bulk$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The collection of banks to update.
     */
    body?: Array<BankUpdate>
}

export function putApiBankV1Bulk$Plain(http: HttpClient, rootUrl: string, params?: PutApiBankV1Bulk$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BankBulkResponse>> {
  const rb = new RequestBuilder(rootUrl, putApiBankV1Bulk$Plain.PATH, 'put');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BankBulkResponse>;
    })
  );
}

putApiBankV1Bulk$Plain.PATH = '/private/v1/banks/bulk';
